<div class="image-border" [ngStyle]="{'margin': centered ? '0px auto' : ''}" [ngClass]="{ 'border-2 border-solid border-portals-accent-900 w-fit': app === 'Jotto' && _shape === 'circle' }">
		<div class="bg-none h-7.5 flex bg-cover bg-center border-2 border-solid items-center justify-center text-2xl no-underline border-portals-theme-primary {{shape}} {{app === 'Jotto' && _shape === 'circle' ? 'border-2 border-solid border-portals-primary-900 rounded-full w-7.5' : ''}}" [ngStyle]="{'margin': centered ? '0px auto' : ''}" [style.background-image]="'url(' + imageUrl + ')'">
			<span *ngIf="text" class="avatar__text">
				{{ text }}
			</span>
		</div>
</div>
